import { render, staticRenderFns } from "./SurveyHome.vue?vue&type=template&id=77015364"
import script from "./SurveyHome.vue?vue&type=script&lang=js"
export * from "./SurveyHome.vue?vue&type=script&lang=js"
import style0 from "./SurveyHome.vue?vue&type=style&index=0&id=77015364&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbsdevops/devops/jenkins-slave/workspace/bizbize-frontend-dev/xpermeet-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77015364')) {
      api.createRecord('77015364', component.options)
    } else {
      api.reload('77015364', component.options)
    }
    module.hot.accept("./SurveyHome.vue?vue&type=template&id=77015364", function () {
      api.rerender('77015364', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Survey/SurveyHome.vue"
export default component.exports